import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  textPrimary: {
    fontWeight: 'bold',
    fontSize: '1.5rem',
    textAlign: 'left',
  },
}))
